import React, { useEffect, useState } from 'react';
import { useAuth } from '../../AuthContext';
import axios from 'axios';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
  Box,
  Grid
} from '@mui/material';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';


const API_URL = process.env.REACT_APP_API_URL;

const UserRefunds = ({onLogout }) => {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);

  const { userId } = useAuth();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSeconds, setLoadingSeconds] = useState(0);

  useEffect(() => {
          let timer;
        
          if (loading) {
            setLoadingSeconds(0); // reset timer
            timer = setInterval(() => {
              setLoadingSeconds(prev => prev + 1);
            }, 1000);
          } else {
            clearInterval(timer);
            setLoadingSeconds(0); // optional reset after done
          }
        
          return () => clearInterval(timer); // cleanup on unmount or loading = false
        }, [loading]);

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const response = await axios.post(`${API_URL}/api/transactions_for_cancelled_sessions/`, { user_id: userId });
        setTransactions(response.data);
      } catch (error) {
        console.error('Error fetching cancelled session transactions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [userId]);

  if (loading) {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(3px)',
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress
          size={60}
          thickness={6}
          sx={{
            color: 'transparent',
            '& .MuiCircularProgress-circle': {
              stroke: 'url(#better-gradient)',
            },
          }}
        />

        {/* Gradient definition */}
        <svg width="0" height="0">
          <defs>
            <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#f30b96ff" />
              <stop offset="50%" stopColor="#221ce0ff" />
              <stop offset="100%" stopColor="#0eacebff" />
            </linearGradient>
          </defs>
        </svg>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            color: '#fff',
            textShadow: '0 1px 3px rgba(0,0,0,0.7)',
          }}
        >
          Loading Refunds Details... ({loadingSeconds} sec)
        </Typography>
      </Box>
    </Box>
  );
}


  return (
    <div>
      <Header1 userId={userId} onLogout={onLogout} />
      <Box sx={{ padding: 3, mt: 10, minHeight: '600px' }}>

        <Typography
          variant="h3"
          component="h1"
          align="center"
          fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
          sx={{
            backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
            mb: 5,
            letterSpacing: 10,
            WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
            color: 'transparent',  // Makes the text itself transparent to show the gradient
          }}
          gutterBottom
        >
          Refunds
        </Typography>



        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={10} md={8}>
            <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" sx={{ fontWeight: 'bold', letterSpacing: 3 }}>Session ID</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold', letterSpacing: 3 }}>Transaction ID</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold', letterSpacing: 3 }}>Amount</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold', letterSpacing: 3 }}>Type</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactions.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        <Typography variant="body1" color="textSecondary" sx={{ letterSpacing: 5 }}>
                          No transactions found.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    transactions.map((transaction) => (
                      <TableRow key={transaction.session_id}>
                        <TableCell align="center" sx={{ letterSpacing: 2 }}>{transaction.session_id}</TableCell>
                        <TableCell align="center" sx={{ letterSpacing: 2 }}>{transaction.transaction_id}</TableCell>
                        <TableCell align="center" sx={{ letterSpacing: 2 }}>INR {transaction.amount.toFixed(2)}</TableCell>
                        <TableCell align="center" sx={{ letterSpacing: 2 }}>{transaction.type}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <Footer2 />
    </div>
  );
};

export default UserRefunds;
